<script>

import helpers from './../../components/Helpers';

export default{
	mixins:[helpers],
	
	props:{
	    isHomePage:{
	        default:false,
        },
		resourceRoute:{
			default:false
		},
		resourceData:{
			default:function(){
				return {};
			}
		},
		itemsPerPage:{
			default:6
		},
		itemsPerRow:{
			default:3
		},
		displayFilterPanel:{
			default:true
		},
		displayLoadMoreBtn:{
			default:true,
		}
	},
	
	data(){
		return {
			resourcesPayLoad:[],
			resourcesLoaded:[],
			gridType:'grid',
			isBusy:false,
			displayHeader:this.displayFilterPanel,
			displayBody:false,
			isLoadMoreDisabled:false,
			selectedCategory:null,
			selectedTopic:null,
			selectedSort:null,
			optionsCategories:{},
			optionsTopics:{},
			optionsSort:{},
			activeCategories:{},
            activeTopics:{},
            firstFilter:null,
			currentPaginationPage:1,
			appliedFilters:{},
		}
	},

    computed:{
	    params(){
	        return this.isHomePage ? {params:{topic:'Feature',per_page:3}} : null;
        },
    },

	methods:{
		
		changeGridType(type){
			this.gridType = type;
			eventsBuffer.$emit('changedGridType', {
				type:type
			});
		},
		
		loadResources(isFilter){

			let isFilterUpdate = isFilter || false;

			return new Promise((resolve, reject ) => {
				if(Object.keys(this.resourceRoute).length){
					this.isBusy = true;

					// console.log(this.buildRoute(),this.params);

					return axios.get(this.buildRoute(),this.params)
						.then(response => {

							this.processResponse(response.data.data.data, isFilterUpdate);

							this.disableMoreButton(response.data.data);

                            this.setFilterOptionsDisabled(response.data.available_filters);
							this.displayBody = true;
							this.isBusy = false;
							
							
							if(!Object.keys(response.data.data).length){
								//return reject('Nothing more to load');
							}
						})
						.catch(error => {
							this.resourcesPayLoad = [];
							this.resourcesLoaded = [];

							this.displayBody = false;
							this.isBusy = false;

						})
				}

				// use the data object to populate the resources
				if(Object.keys(this.resourceData).length){
					//?sort=email%7Casc&page=1&per_page=10
				}

				// alert no source where given
				this.displayBody = false;
			})
		},
		
		/**
		 * @param payload object
		 * @param isFilterUpdate bool
		*/
	    processResponse(payload, isFilterUpdate){



			this.resourcesPayLoad = this.chunkMap(payload, this.itemsPerRow);
			
			if(isFilterUpdate){
				return this.resourcesLoaded = this.resourcesPayLoad;

			}
			
			this.appendToCurrentLoadedResources(this.resourcesPayLoad);
		},
		
		/**
		 * Load more action button
		*/
		loadMore(){
			this.appliedFilters.page++;
			this.currentPaginationPage++;
			this.loadResources()
				.catch(()=> {
					this.appliedFilters.page--;
					this.currentPaginationPage--;
				});
		},
		
		/**
		 * Append incoming payload resoureces to in memory resources
		*/
	    appendToCurrentLoadedResources(currentPayload){
			currentPayload.forEach((item) => {
				this.resourcesLoaded.push(item)
			})
		},

		buildRoute(){
            if(this.isHomePage)return this.resourceRoute;
            this.appliedFilters.typetag = 'resources'
			let filters = Object.keys(this.appliedFilters).map((item, key) => {
				return `${item}=${this.appliedFilters[item]}`;
			});

			return `${this.resourceRoute}?${filters.join('&')}`;
		},
		
		/**
		 * ApplyFilter action
		*/
	    applyFilter(filter){
			this.updateFilters(filter)
				.then(()=>{
				    if(filter !== 'sort'){
                        this.firstFilter = this.firstFilter === null || this.firstFilter === filter
                            ? filter
                            : this.firstFilter;
                    }
					this.loadResources(true);

                }).catch( error => {
					if(this.appliedFilters.hasOwnProperty(filter)){
						console.log(error)
						delete this.appliedFilters[filter];
						this.loadResources(true);
					}
					
				})
		},
		
		/**
		 * update applied filters
		*/
	    updateFilters(filterKey){
			return new Promise((resolve, reject) => {

				let filterName = 'selected' + this.ucfirst(filterKey);
				
				if(!this.hasOwnProperty(filterName)) return reject(filterName);
				
				// reset curren page
				this.resetPagination();
                // console.log(filterName,this.$data);
				this.appliedFilters[filterKey] = filterKey === 'sort' && this.$data[filterName] !== ''
					? `${this.$data[filterName]}%7C${this.$data.optionsSort[this.$data[filterName]].sort}`
					: this.$data[filterName];
				
				return resolve();
			})
		},
		
		/**
		 * build default query string params
		 */
		appliedBasicFilters(){
			this.appliedFilters['per_page'] = this.itemsPerPage * this.currentPaginationPage;
			this.appliedFilters['page'] = this.currentPaginationPage;
		},

		/**
		 * sets loadmore button disable status
		 * @param payload
		 */
		disableMoreButton(payload){
			if(payload && payload.hasOwnProperty('links') && payload.links.hasOwnProperty('pagination')){
				this.isLoadMoreDisabled = this.currentPaginationPage >=  payload.links.pagination.total_pages;
			}
		},
		
		resetPagination(){
			this.$data.currentPaginationPage = 1;
			this.appliedFilters.page = 1;
		},

        createActiveOptions(){
		    Object.keys(this.optionsCategories).forEach(key=>{
		        this.activeCategories[key]= true;
            });
            Object.keys(this.optionsTopics).forEach(key=>{
		        this.activeTopics[key]= true;
            })
        },

        clearFilters(){
		    this.selectedCategory= "";
		    this.selectedTopic= "";
		    this.selectedSort= "";
		    this.firstFilter= null;
            this.appliedFilters = {
                page:1,
                per_page:6,
                typetag:"resources"
            };
            this.resourcesPayLoad=[];
            this.resourcesLoaded=[];
            for (let x in this.activeTopics){
                this.activeTopics[x]=true
            }
            for (let x in this.activeCategories){
                this.activeCategories[x]=true
            }
            this.loadResources();
        },

        setFilterOptionsDisabled(availableFilters){
            console.log(availableFilters);

            if(this.firstFilter===null){
                for (let x in this.activeTopics){
                    this.activeTopics[x]=false
                }

                for (let x in this.activeCategories){
                    this.activeCategories[x]=false;
                }

                availableFilters['topics'].forEach(tag=>{
                    this.activeTopics[tag]=true;
                });

                availableFilters['category'].forEach(category=>{
                    this.activeCategories[category] = true;
                })
            }

            if(this.firstFilter === 'category'){
                for (let x in this.activeTopics){
                    this.activeTopics[x]=false
                }
                availableFilters['topics'].forEach(tag=>{
                    this.activeTopics[tag]=true;
                });
            }

            if(this.firstFilter === 'topic'){
                for (let x in this.activeCategories){
                    this.activeCategories[x]=false;
                }
                availableFilters['category'].forEach(category=>{
                    this.activeCategories[category] = true;
                })
            }

        }

	},

	mounted(){
		document.addEventListener('DOMContentLoaded', () => {
			this.appliedBasicFilters();
			this.loadResources();
			this.optionsCategories = window.App.app.categories;
			this.optionsTopics = window.App.app.topics;
			this.optionsSort = window.App.app.resourcesOrderOptions;
			this.createActiveOptions();
		});
	}
}
</script>

<template>
	<div class="row">
		<div class="container-filters">
			<div class="panel">
				<div v-if="displayHeader" class="panel-header">
					<div class="filter-container">
						<div class="container">
							<div class="filter-options">

								<div class="filter-item">
									
									<label>Show me</label>
									
									<el-select placeholder="All Resources"
                                               size="large"
                                               :clearable="false"
                                               v-model="selectedCategory"
						                        @change="applyFilter('category')">
										<el-option label="All Resources" key="all-resources" value="">All Resources</el-option>
										<el-option
										v-for="category in optionsCategories"
                                        :disabled="!activeCategories[category.slug]"
										:key="category.slug"
										:label="category.name"
										:value="category.slug">

										</el-option>
									</el-select>
								</div>

								<div class="filter-item">
									<label>on</label>
									<el-select placeholder="All Topics"
                                               size="large"
                                               :clearable="false"
                                               v-model="selectedTopic"
                                               @change="applyFilter('topic')">
                                        <el-option label="All Topics" key="all-topics" value="">All Topics</el-option>

                                        <el-option
										v-for="topic in optionsTopics"
                                        :disabled="!activeTopics[topic.slug.en]"
										:key="topic.slug.en"
										:label="topic.name.en"
										:value="topic.name.en">
										</el-option>
									</el-select>
								</div>
								
								<div class="filter-item">
									<label>from</label>
									<el-select placeholder="Order By" size="large" :clearable="true"
						            v-model="selectedSort"
						            @change="applyFilter('sort').intro-paragraph">
										
										<el-option
										v-for="sortItem in optionsSort"
										:key="sortItem.slug"
										:label="sortItem.name"
										:value="sortItem.slug">
										</el-option>
									
									</el-select>
								</div>
							</div>

							<div class="filter-buttons">
                                    <i class="fas fa-redo text-light mr-3" style="font-size: 18px" @click="clearFilters"></i>
                                <!--<button class="btn btn-light">-->
                                <!--</button>-->
								<prolit-button plain @click="changeGridType('grid')" :active="true" name="grid">
									<i class="fas fa-th"></i>
								</prolit-button>
								<prolit-button plain @click="changeGridType('list')" :active="false" name="list">
									<i class="fas fa-list"></i>
								</prolit-button>


							</div>
						</div>
					</div>
				</div>
				<div class="container-grid">
					<div class="container">
						<div class="card-deck panel-body">
							<slot v-if="displayBody" :data="resourcesLoaded" :type="gridType"></slot>
							<div v-else>
								<h3 class="text-center">No data available</h3>
							</div>
						</div>
						<div class="row mb-5" v-if="displayLoadMoreBtn">
							<div class="col text-center load-more">
								<el-button type="success" size="large" round
					            :disabled="isLoadMoreDisabled"
					            :loading="isBusy"
					            @click="loadMore()">
									Load More&nbsp;
									<i v-if="!isBusy" class="fas fa-chevron-right"></i>
								</el-button>
							</div>
						</div>
						
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<style scoped>
	.container-filters {
		float: left;
		width: 100%;
		background: #F5F8F9;
	}
	.card-deck .card {
		margin: 0;
	}
	.panel-header {
	}
	.filter-container {
		padding: 10px 0;
	}
	.filter-container label {
		color: white;
		font-weight: bold;
	}
	.panel .panel-body {
		padding: 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/resources/ResourcesPanel.vue